import { AjaxForm } from "@neonjungle/birdseed/forms/ajax";

export default function setupSubscribeForms() {
	document.querySelectorAll("form[data-subscribe]").forEach((formEl) => {
		new AjaxForm(formEl);
	});
}
